import React, { useState } from "react";
import ResponsiveWrapper from "../_responsive-wrapper";
import patioData from "../../components/patio-configurator/data";
import { ReactComponent as StarIcon } from "../../assets/svgs/star-table-comparison.svg";
import { badgesByVehicles } from "../../components/collection/data";

const RatingStars = ({ rating }) => (
    <div className="table-comparison__rating">
        {[...Array(rating)].map(() => (
            <span
                className="table-comparison__star--active"
            >
                <StarIcon />
            </span>
        ))}
    </div>
);

const TableComparison = () => {
    const variants = ["Supreme", "Elite", "Proguard"];
    const [activeTab, setActiveTab] = useState(variants[0]);
    const { variantText } = patioData;

    /*
    Gray - #98a1a7
    Beige - #998e76
    Black - #262626
    Navy Blue - #21364f
    Sky Blue - #1a6eb7
    Coffee Brown - #533a38
    Red - #d53d42

    Gray - #98a1a7
    Beige - #998e76
    Black - #262626
    Navy Blue - #21364f

    Gray - #98a1a7
    Beige - #998e76
    Sky Blue - #1a6eb7
     */


    const colors = {
        supreme:  ["#98a1a7", "#998e76", "#262626", "#21364f", "#1a6eb7", "#533a38", "#d53d42"],
        elite: ["#98a1a7", "#998e76", "#262626", "#21364f"],
        proguard: ["#98a1a7", "#998e76", "#262626"],
    };

    const ratings = {
        supreme: {
            waterproof: 5,
            durability: 5,
            uvResistant: 5,
            breathability: 5,
        },
        elite: {
            waterproof: 4,
            durability: 4,
            uvResistant: 3,
            breathability: 2,
        },
        proguard: {
            waterproof: 3,
            durability: 3,
            uvResistant: 5,
            breathability: 5,
        },
    };

    const ratingRows = [
        { key: "waterproof", label: "Waterproof" },
        { key: "durability", label: "Durability" },
        { key: "uvResistant", label: "UV Resistant" },
        { key: "breathability", label: "Breathability" },
    ];

    const warrantyBadges = {
        supreme: badgesByVehicles[0].badges.find((badge) => badge.key === "supreme").Component,
        elite: badgesByVehicles[0].badges.find((badge) => badge.key === "elite").Component,
        proguard: badgesByVehicles[5].badges.find((badge) => badge.key === "proguard").Component,
    };

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
    };

    return (
        <ResponsiveWrapper className="table-comparison">
            <div className="table-comparison__inner">
                <div className="table-comparison__tabs">
                    {variants.map((variant) => (
                        <button
                            key={variant}
                            type="button"
                            className={`table-comparison__tab table-comparison__tab--${variant.toLowerCase()} ${activeTab === variant ? "table-comparison__tab--active" : ""}`}
                            onClick={() => handleTabChange(variant)}
                        >
                            {variant}
                        </button>
                    ))}
                </div>

                <div className="table-comparison__content">
                    <div className="table-comparison__header">
                        <div className="table-comparison__col table-comparison__col--label">
                            Comparisons by Collections:
                        </div>
                        {variants.map((variant) => (
                            <div
                                key={variant}
                                className={`table-comparison__col table-comparison__col--${variant.toLowerCase()} ${activeTab === variant ? "table-comparison__col--active" : ""}`}
                            >
                                {variant}
                            </div>
                        ))}
                    </div>

                    <div className="table-comparison__row">
                        <div className="table-comparison__col table-comparison__col--label">
                            Color:
                        </div>
                        {variants.map((variant) => (
                            <div
                                key={variant}
                                className={`table-comparison__col ${activeTab === variant ? "table-comparison__col--active" : ""}`}
                            >
                                <div className="table-comparison__colors">
                                    {colors[variant.toLowerCase()].map((color, index) => (
                                        <span
                                            key={index}
                                            className="table-comparison__color"
                                            style={{ backgroundColor: color }}
                                        />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="table-comparison__row">
                        <div className="table-comparison__col table-comparison__col--label">
                            Material:
                        </div>
                        {variants.map((variant) => (
                            <div
                                key={variant}
                                className={`table-comparison__col ${activeTab === variant ? "table-comparison__col--active" : ""}`}
                            >
                                {variantText[variant.toLowerCase()].find((item) => item.key === "material")?.value}
                            </div>
                        ))}
                    </div>

                    <div className="table-comparison__row">
                        <div className="table-comparison__col table-comparison__col--label">
                            Feature:
                        </div>
                        {variants.map((variant) => (
                            <div
                                key={variant}
                                className={`table-comparison__col ${activeTab === variant ? "table-comparison__col--active" : ""}`}
                            >
                                {variantText[variant.toLowerCase()].find((item) => item.key === "feature")?.value}
                            </div>
                        ))}
                    </div>

                    <div className="table-comparison__row">
                        <div className="table-comparison__col table-comparison__col--label">
                            Ideal for:
                        </div>
                        {variants.map((variant) => (
                            <div
                                key={variant}
                                className={`table-comparison__col ${activeTab === variant ? "table-comparison__col--active" : ""}`}
                            >
                                {variantText[variant.toLowerCase()].find((item) => item.key === "ideal for")?.value}
                            </div>
                        ))}
                    </div>

                    {ratingRows.map(({ key, label }) => (
                        <div className="table-comparison__row" key={key}>
                            <div className="table-comparison__col table-comparison__col--label">
                                {label}
                                :
                            </div>
                            {variants.map((variant) => (
                                <div
                                    key={variant}
                                    className={`table-comparison__col ${activeTab === variant ? "table-comparison__col--active" : ""}`}
                                >
                                    <RatingStars rating={ratings[variant.toLowerCase()][key]} />
                                </div>
                            ))}
                        </div>
                    ))}

                    <div className="table-comparison__row">
                        <div className="table-comparison__col table-comparison__col--label">
                            Warranty:
                        </div>
                        {variants.map((variant) => (
                            <div
                                key={variant}
                                className={`table-comparison__col ${activeTab === variant ? "table-comparison__col--active" : ""}`}
                            >
                                <div className="table-comparison__warranty">
                                    {warrantyBadges[variant.toLowerCase()]}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </ResponsiveWrapper>
    );
};

export default TableComparison;
